export enum Language {
  Norwegian = 'no'
}
